import { render, staticRenderFns } from "./BoardsPage.vue?vue&type=template&id=4481fd1a&"
import script from "./BoardsPage.vue?vue&type=script&lang=js&"
export * from "./BoardsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports